import { Component, OnInit } from '@angular/core';
import { BBWTMessageService, TelephonyService } from '../../../services';
import { CallEventSubscription } from '../../../interfaces/telephony/call-event-subscription';

@Component({
  selector: 'app-telephony-webhooks',
  templateUrl: './telephony-webhooks.component.html',
  styleUrls: ['./telephony-webhooks.component.scss'],
})
export class TelephonyWebhooksComponent implements OnInit {
  constructor(
    private telephonyService: TelephonyService,
    private messageService: BBWTMessageService,
  ) {}

  isLoadingSubscriptions: boolean = false;

  isCreatingSubscriptions: boolean = false;

  callEventSubscriptions: CallEventSubscription[] = [];

  ngOnInit(): void {
    void this.getWebhooks();
  }

  private async getWebhooks(): Promise<void> {
    try {
      this.isLoadingSubscriptions = true;
      this.callEventSubscriptions = await this.telephonyService.getCallEventSubscriptions();
    } catch (error) {
      this.messageService.ShowError('Error', 'Failed to retrieve webhooks');
    } finally {
      this.isLoadingSubscriptions = false;
    }
  }

  asCallEventSubscription(itemUntyped: any): CallEventSubscription {
    return itemUntyped as CallEventSubscription;
  }

  async setupSubscriptions() {
    try {
      this.isCreatingSubscriptions = true;
      await this.telephonyService.setupCallEventSubscriptions();
      this.messageService.ShowSuccess('Success', 'Subscriptions setup successfully');
      void this.getWebhooks();
    } catch (error) {
      this.isCreatingSubscriptions = false;
      this.messageService.ShowError('Error', 'Failed to setup subscriptions');
    }
  }
}
